import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'aptar-tile-container',
  template: `
  <div class="tiles-dashboard">
  <ng-container>
    <div class="grid-layout">
      	<ng-content></ng-content>
    </div>
  </ng-container>
</div>
  `,
  styles: []
})
export class TileContainerComponent implements OnInit {
  constructor() {
  }

  ngOnInit(): void {

  }
}
